import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useParams } from "react-router-dom";

import LeftChatBox from "./LeftChatBox";
import RightChatBox from "./RightChatBox";
import { useTicketContext } from "../../context/TicketContext";
import storage from "../../helpers/storage";

const Message = ({ message }) => {
  const currentUserId = storage.getUserName();
  const isLoggedInUser = message.sender === currentUserId;

  const formattedMessage = (
    <pre
      style={{
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        fontFamily: "monospace",
      }}
    >
      {message.message}
    </pre>
  );

  if (isLoggedInUser) {
    return <RightChatBox {...message} message={formattedMessage} />;
  }

  if (!isLoggedInUser) {
    return <LeftChatBox {...message} message={formattedMessage} />;
  }
};


const Chat = () => {
  let { id } = useParams();
  const location = useLocation();
  const { loading, ticket, sendMessage, isBtnDisabled, createSignedUrl } =
    useTicketContext();
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [requestLoading, setRequestLoading] = useState(false);

  const containerRef = useRef(null);
  const fileInputRef = useRef(null);

  const addMessage = () => {
    console.log({ message });
    const newMessage = {
      sender: storage.getUserName(),
      type: "message",
      message: message,
      updated_at: new Date(),
    };

    if (Array.isArray(messages)) {
      setMessages([...messages, newMessage]);
    } else {
      console.error("Error: messages is not an array");
      setMessages([newMessage]);
    }
    setMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setRequestLoading(true);

      if (!message && fileInputRef.current.files.length <= 0) {
        toast.error("Please enter some text or attach a file");
        return;
      }
      if (fileInputRef.current.files.length > 0) {
        const file = fileInputRef.current.files[0];
        console.log({ submitfile: file });
        await createSignedUrl(file);
        handleCloseClick();
        return;
      }
      if (message.length > 0) {
        sendMessage(message);
        addMessage();
      }
    } catch (error) {
      toast.error("Oops something went wrong file sending the message");
    } finally {
      setRequestLoading(false);
    }
  };

  const handleFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    setSelectedFile(fileUploaded);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleCloseClick = () => {
    setSelectedFile(null);
    fileInputRef.current.value = ""; // Clear the file input value
  };

  useEffect(() => {
    setMessages(ticket?.messages);
  }, [ticket]);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      const element = containerRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [containerRef, messages, requestLoading]);

  const hasAssigneeInPath = location.pathname?.includes("assignee-history");

  return (
    <>
      {!hasAssigneeInPath && (
        <Link
          to={`/manage-ticket/ticket/edit/${id}/assignee-history`}
          className={`mt-10 flex justify-end mb-2 underline `}
        >
        </Link>
      )}

      <div
        className={`chat flex flex-col px-4 ${
          hasAssigneeInPath ? "h-full" : "h-cal-400"
        }`}
      >
        <div
          ref={containerRef}
          className="flex-1 overflow-scroll scroll-container scroll-py-4 py-5 flex flex-col space-y-5"
        >
          {loading &&
            Array(10)
              .fill(0)
              .map((_, index) => (
                <div key={index} className="flex flex-col">
                  <div
                    className={`size-76 loading-custom rounded-full mb-1 flex ${
                      index % 2 === 0 ? "align-self-end" : "align-start"
                    }`}
                  />

                  <h4 className="loading-custom h-106 mb-4 "></h4>
                </div>
              ))}
          {messages?.map((message, index) => (
            <Message key={index} message={message} />
          ))}

          {requestLoading && (
            <div className="flex flex-col">
              <div
                className={`size-76 loading-custom rounded-full  mb-1 flex align-self-end`}
              />
              <h4 className="loading-custom h-106 mb-2 "></h4>
            </div>
          )}
        </div>

        <div className="flex-[.2] flex w-full items-end pb-4 ">
          <form
            onSubmit={handleSubmit}
            className="flex  items-center justify-between border h-130 w-full"
          >
            <div className="w-full h-full relative">
              {selectedFile ? (
                <div className="flex items-center justify-center h-full bg-white">
                  <div className=" border p-2 rounded  space-x-4 flex">
                    <span>{selectedFile.name}</span>
                    <button
                      className="border-none bg-transparent p-0 text-red "
                      onClick={handleCloseClick}
                    >
                      X
                    </button>
                  </div>
                </div>
              ) : (
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full h-full p-4 border-none mb-2  scroll-container rounded-md resize-none"
                  placeholder="Type your message"
                />
              )}
              {/* attach or send btn   */}
              <div className=" absolute bottom-2 right-2 flex space-x-4 px-2">
                <button
                  className="border-none bg-transparent p-0"
                  onClick={handleButtonClick}
                  type="button"
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <img src="/attach-file.svg" alt="attach-svg" />
                </button>

                <button
                  disabled={isBtnDisabled}
                  className="border-none bg-transparent p-0 "
                  type="submit"
                >
                  <img src="/send.svg" alt="send-svg" className="size-32" />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Chat;
